module.exports = __webpack_public_path__ + "media/images/menu/icn-cart-e768619c7f3bf1574c165b1da0803b61.svg";